<script>
	import { onMount, beforeUpdate, afterUpdate} from 'svelte';
	import { cart } from '../models/cart.js';
	import { stripe } from '../services/stripe.js';
	import { checkSession } from '../models/orders.js';
  import { formatPrice } from '../services/utilities.js';
	import CartItem from '../components/CartItem.svelte';

  export let isAdmin = false;
	export let compact = false;
	export let editable = true;
	export let items = null;
	export let onUpdate = null;
	export let returnToStock;

	let checkingOut = window.location.href.indexOf('checkout') >= 0;
	let sumQuant = (acc, curr) => acc + Number(curr.quantity);
	let sumPrice = (acc, curr) => {
		let activePrice = Number(curr.sale_price) || Number(curr.price);
		return acc + (activePrice * curr.quantity);
	}

	beforeUpdate(async () => {
		// if its not checkout page and there is
		// an existing session ID, lets check intent
		if (!checkingOut) {
			let sessionID = stripe.getSessionIDStored();
			if (sessionID) {
				// handle intent
				let sessionData = await checkSession(sessionID);
				if (sessionData.status && (sessionData.status !== "Pending" && sessionData.status !== "Cancelled")){
					// if the session is not in Pending or Cancelled state, the order succeeed
					// lets empty the cart
					cart.empty();
				}
				
				// clear sessionID
				stripe.storeSession("");
			}
		}
	});

	afterUpdate(() => {
		if(onUpdate){
			onUpdate();
		}
	});
</script>

<style>
  .cart {
    min-width: 250px;
    margin: var(--spacing-sm) auto;
  }

  .cart-list {
    list-style: none;
    padding: 0;
    margin: 0;
    border-width: 0;
    overflow-y: auto;
    z-index: 1000;
  }

  .compact.cart-list {
    max-height: 250px;
  }

  .cart-total {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--spacing-sm);
    box-sizing: border-box;
    border-top: solid 1px var(--col-accent-2);
  }

  .cart-item-info {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-width: 0;
    font-size: 0.9rem;
    font-weight: 700;
    line-height: var(--line-height);
  }
  .cart-item-title {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 1rem;
  }

  .cart-item-quantity {
    flex-shrink: 0;
    line-height: var(--line-height);
    text-align: center;
    width: 5rem;
    padding: 0 var(--spacing-sm);
  }

  .cart-item-price {
    width: 6ch;
    text-align: right;
  }

  .cart-message {
    text-align: center;
  }
</style>

<section class="cart" class:card={!compact && editable}>
  {#if $cart.length === 0 && !items}
    <p class="cart-message">Oh no! Your cart is empty!</p>
  {/if}

  {#if items || $cart.length}
    <ul class="cart-list" class:compact>
      {#if items}
        {#each items as p}
          <CartItem
            product={p}
            {isAdmin}
            {compact}
            {editable}
            {returnToStock} />
        {/each}
      {:else}
        {#each $cart as p}
          <CartItem product={p} {compact} {editable} />
        {/each}
      {/if}
    </ul>
  {/if}

  {#if !items && $cart.length}
    <div class="cart-total">
      <span class="cart-item-info">
        <span class="cart-item-title">Subtotal</span>
      </span>
      <span class="cart-item-quantity" class:hidden={compact}>
        {$cart.reduce(sumQuant, 0)}
      </span>
      <span class="cart-item-price">
        {formatPrice($cart.reduce(sumPrice, 0))}
      </span>
    </div>
  {/if}
</section>
